import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "../components/Footer";
import { Truck, Users, Box, Layers, Infinity } from 'lucide-react';

export default function Pricing({ isAuthenticated, setIsAuthenticated }) {
  const fileLink = isAuthenticated ? "/dashboard" : "/sign-up";

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsAuthenticated(false);
      return;
    }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp * 1000 < Date.now()) throw new Error("expired");
    } catch {
      localStorage.removeItem("token");
      setIsAuthenticated(false);
      return;
    }
    fetch("/api/users-logic/me/", { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        if (!res.ok) {
          localStorage.removeItem("token");
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      })
      .catch(() => {});
  }, [setIsAuthenticated]);

  return (
    <div className="bg-white text-[#0F2C5E] flex flex-col min-h-screen font-sans">
      <Header isAuthenticated={isAuthenticated} />
      <main className="flex-grow px-4 py-14">
        <h2 className="text-xl sm:text-2xl font-bold mb-8 uppercase tracking-wide text-center">
          Pricing
        </h2>
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { label: "1 Vehicle",       price: "$19.99", icon: Truck     },
              { label: "2–24 Vehicles",   price: "$24.99", icon: Users     },
              { label: "25–100 Vehicles", price: "$34.99", icon: Box       },
              { label: "101–250 Vehicles",price: "$49.99", icon: Layers    }
            ].map((plan, i) => (
              <div key={i} className="bg-gray-100 p-6 rounded-lg shadow-sm flex flex-col items-center">
                <plan.icon size={48} className="mb-4 text-[#0F2C5E]" />
                <p className="text-sm font-medium mb-1">{plan.label}</p>
                <p className="text-2xl font-bold text-[#0F2C5E] mb-4">{plan.price}</p>
                <Link to={fileLink} className="w-full">
                  <button className="w-full bg-[#0F2C5E] text-white py-2 rounded hover:bg-[#173B6F] transition text-sm">
                    File Now
                  </button>
                </Link>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { label: "251–1000 Vehicles", price: "$74.99", icon: Infinity },
                { label: "1001+ Vehicles",     price: "$99.99", icon: Truck    },
                { label: "Unlimited (1 company, 1 tax year)", price: "$199", icon: Infinity }
              ].map((plan, i) => (
                <div key={i} className="bg-gray-100 p-6 rounded-lg shadow-sm flex flex-col items-center">
                  <plan.icon size={48} className="mb-4 text-[#0F2C5E]" />
                  <p className="text-sm font-medium mb-1">{plan.label}</p>
                  <p className="text-2xl font-bold text-[#0F2C5E] mb-4">{plan.price}</p>
                  <Link to={fileLink} className="w-full">
                    <button className="w-full bg-[#0F2C5E] text-white py-2 rounded hover:bg-[#173B6F] transition text-sm">
                      File Now
                    </button>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
